import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TRegistryInstitution {
  code: string;
  name: string;
  valid: boolean;
  description: string;
}

export interface IRegistryInstitution extends TRegistryInstitution {}

const RegistryInstitution = Model(
  (model: TRegistryInstitution): IRegistryInstitution => {
    const _value: TRegistryInstitution = Object.assign({}, model);

    let _model = {
      get code() {
        return _value.code;
      },
      set code(value) {
        _value.code = value;
      },

      get name() {
        return _value.name;
      },
      set name(value) {
        _value.name = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      },
      get description() {
        return _value.description;
      },
      set description(value) {
        _value.description = value;
      }
    };

    return ValidatableObject<IRegistryInstitution>(_model);
  }
);

export default RegistryInstitution;
